import React from 'react';

export const EmptyState = ({ icon: Icon, title, description, children }) => (
  <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-white/10 bg-surface/40 px-6 py-16 text-center">
    {Icon && (
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/5 text-white/40">
        <Icon className="h-7 w-7" />
      </span>
    )}
    <h3 className="mt-5 font-display text-lg font-semibold text-white">{title}</h3>
    <p className="mt-2 max-w-md text-sm leading-relaxed text-white/50">{description}</p>
    {children && <div className="mt-5">{children}</div>}
  </div>
);
